import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { isType3, userTypeList } from 'main_consts';

import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

import CheckBox from 'components/Material/Checkbox';
import { EnumDeclType, EnumTimeCheck } from 'enum';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getColWidthByField,
  getWarehouse,
  inputChange,
  radioChange,
  checkboxChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';

import Table from '../../../components/Material/Table/index';
import { Imaster } from './type';
import { EnumMaster } from './enum';

/** 已放行未出倉清單 */
const ExpNotGcoQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    [EnumMaster.declType]: EnumDeclType.進口,
    // 記帳代號
    [EnumMaster.chkCode1]:
      (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    [EnumMaster.expressCnName]: '',
    // 快遞倉站
    [EnumMaster.warehouse]:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 日期
    [EnumMaster.startDate]: getDateDayPlus(),
    [EnumMaster.endDate]: getDateDayPlus(),
    [EnumMaster.startTime]: '0000',
    [EnumMaster.endTime]: '2359',
    [EnumMaster.endDateValid]: true,
    [EnumMaster.endTimeValid]: true,
    [EnumMaster.startDateValid]: true,
    [EnumMaster.startTimeValid]: true,
    [EnumMaster.mawbNo]: '',
    [EnumMaster.timeCheck]: EnumTimeCheck.關,
  };
  const apiName = 'expNotGcoQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<Imaster[]>([]);
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      mawbNo: master[EnumMaster.mawbNo],
      chkCode1: master[EnumMaster.chkCode1],
      warehouse: master[EnumMaster.warehouse],
      declType: master[EnumMaster.declType],
      startDate:
        master[EnumMaster.timeCheck] === EnumTimeCheck.開
          ? formatDateTime(
              master[EnumMaster.startDate],
              `${master[EnumMaster.startTime]}00`
            )
          : '',
      endDate:
        master[EnumMaster.timeCheck] === EnumTimeCheck.開
          ? formatDateTime(
              master[EnumMaster.endDate],
              `${master[EnumMaster.endTime]}59`
            )
          : '',
    });
    const startDate = formatDateTime(
      master[EnumMaster.startDate],
      master[EnumMaster.startTime],
      'MMdd'
    );
    const EndDate = formatDateTime(
      master[EnumMaster.endDate],
      master[EnumMaster.endTime],
      'MMdd'
    );

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master[EnumMaster.chkCode1].length > 0
          ? `${master[EnumMaster.chkCode1]}_`
          : ''
      }${startDate}_${EndDate}_已放行未出倉清單.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      chkCode1: master[EnumMaster.chkCode1],
      warehouse: master[EnumMaster.warehouse],
      declType: master[EnumMaster.declType],
      startDate:
        master[EnumMaster.timeCheck] === EnumTimeCheck.開
          ? formatDateTime(
              master[EnumMaster.startDate],
              `${master[EnumMaster.startTime]}00`
            )
          : '',
      endDate:
        master[EnumMaster.timeCheck] === EnumTimeCheck.開
          ? formatDateTime(
              master[EnumMaster.endDate],
              `${master[EnumMaster.endTime]}59`
            )
          : '',
      mawbNo: master[EnumMaster.mawbNo],
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    const data = dataTemp as Imaster[];
    if ((data || []).length > 0) {
      setColList(
        getColWidthByField([
          { headerName: '項次', field: 'itemNo' },
          { headerName: '主號', field: 'mawbNo' },
          { headerName: '分號', field: 'hawbNo' },
          { headerName: '報單號碼', field: 'declNo' },
          { headerName: '申報', field: 'piece' },
          { headerName: '進倉', field: 'gciPiece' },
          { headerName: '出倉', field: 'gcoPiece' },
          { headerName: '放行時間', field: 'relDate' },
          { headerName: '進倉時間', field: 'gciDate1' },
          { headerName: '出倉時間', field: 'gcoDate1' },
          { headerName: '通關方式', field: 'goodsStat' },
          { headerName: '併袋號碼', field: 'expBagNo' },
          { headerName: '海掛', field: 'vesselRegNo' },
          {
            headerName:
              master[EnumMaster.declType] === EnumDeclType.進口
                ? '艙號'
                : '裝貨單號',
            field: 'manifNo',
          },
          { headerName: '類別', field: 'appType' },
          { headerName: '快遞倉站', field: 'warehouse' },
          { headerName: '報關箱號', field: 'boxNo' },
          { headerName: '貨櫃號碼', field: 'containerNo' },
        ])
      );
      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (
      master[EnumMaster.mawbNo].length <= 0 &&
      master[EnumMaster.timeCheck] === EnumTimeCheck.關
    ) {
      enqueueSnackbar('【主號】或【查詢日期區間】擇一必填。', {
        variant: 'warning',
      });
      return;
    }

    if (
      (master[EnumMaster.timeCheck] === EnumTimeCheck.開 &&
        (!master[EnumMaster.endDateValid] ||
          !master[EnumMaster.endTimeValid] ||
          !master[EnumMaster.startDateValid] ||
          !master[EnumMaster.startTimeValid])) ||
      !(
        master[EnumMaster.startDate] &&
        master[EnumMaster.endTime] &&
        master[EnumMaster.startDate] &&
        master[EnumMaster.startTime]
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  return (
    // <div id="page-area">
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">已放行未出倉清單查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 已放行未出倉清單查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name={EnumMaster.declType}
                value={master[EnumMaster.declType]}
                onChange={radioChange(updateData)}
                options={[
                  { value: EnumDeclType.進口, label: '進口' },
                  { value: EnumDeclType.出口, label: '出口' },
                ]}
              />
            </VcGrid>
          </Grid>

          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name={EnumMaster.chkCode1}
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master[EnumMaster.chkCode1]}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master[EnumMaster.warehouse]}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              主號：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                placeholder="主號或查詢日期區間擇一必填"
                maxLength={35}
                value={master[EnumMaster.mawbNo]}
                name={EnumMaster.mawbNo}
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>查詢日期區間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master[EnumMaster.timeCheck] === EnumTimeCheck.開}
                disabled={master[EnumMaster.timeCheck] === EnumTimeCheck.關}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  [EnumMaster.startDate, EnumMaster.startTime],
                  [EnumMaster.endDate, EnumMaster.endTime],
                ]}
                data={master}
                setDayRange={3}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master[EnumMaster.timeCheck] === EnumTimeCheck.開}
                name={EnumMaster.timeCheck}
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue[EnumMaster.startDate],
                    startTime: masterDefaultValue[EnumMaster.startTime],
                    endDate: masterDefaultValue[EnumMaster.endDate],
                    endTime: masterDefaultValue[EnumMaster.endTime],
                    ...checkboxChange()([EnumTimeCheck.開, EnumTimeCheck.關])(
                      e
                    ),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <Table
          key={randomValue}
          data={rowData as unknown as Iobject[]}
          columns={colList}
          rowsPerPageOptions={[100, 50, 10]}
          rootProps={{ style: { height: '400px' } }}
          pageSize={100}
        />
      )}
    </div>
  );
};

export default ExpNotGcoQry;
